import { render } from "./PartnerPayments.vue?vue&type=template&id=03393aba&scoped=true"
import script from "./PartnerPayments.vue?vue&type=script&lang=js"
export * from "./PartnerPayments.vue?vue&type=script&lang=js"

import "./PartnerPayments.vue?vue&type=style&index=0&id=03393aba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03393aba"]])

export default __exports__